import { observer } from 'mobx-react';

export interface IMapWrapperProps {
  children?: React.ReactNode;
}

export default observer(function MapWrapper({ children }: IMapWrapperProps) {
  return <div className={'MapWrapper'}>{children}</div>
});
